import { Request } from '@/classes/Request.ts'
import { Util } from '@/modules/util'

export interface LetterLogEntry {
  letterId: number
  districtId: number
  districtName: string
  letterTypeId: number
  logCreatedAt: Date
  logCreatedAtFormatted: string
}

export const listLetters = async (letterTypes?: number[]): Promise<LetterLogEntry[]> => {
  return new Promise<LetterLogEntry[]>(async resolve => {
    let params = {} as any

    if (letterTypes !== undefined) {
      params.letter_types = letterTypes.join(',')
    }

    const response = await new Request().get('/ajax/documents/letters', params)
    resolve(
      Util.Obj.keysToCamel(response.data.letters).map((letter: any) => {
        letter.logCreatedAtFormatted = new Date(
          Date.parse(letter.logCreatedAt)
        ).toLocaleDateString()
        return letter as LetterLogEntry
      })
    )
  })
}
